import { useEffect, useState, RefObject } from 'react';

interface UseIntersectionObserverOptions {
  elementRef: RefObject<Element>;
  threshold?: number | number[];
  rootMargin?: string;
  root?: Element | null;
}

export const useIntersectionObserver = ({
  elementRef,
  threshold = 0.1,
  rootMargin = '0px',
  root = null,
}: UseIntersectionObserverOptions) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      {
        threshold,
        rootMargin,
        root,
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [elementRef, threshold, rootMargin, root]);

  return { isIntersecting };
};
